import { Link } from 'react-router-dom'
import React, {useContext, useEffect, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../services/api'
import { DataTableOptions } from '../../components/dataTableOptions'
import {MainContext} from "../../context/MainContext";

export default function ListingClub() {
  const {setPageTitle, setLoading} = useContext(MainContext)
  const [clubs, setClubs] = useState<any>([])

  const getClubs = async () => {
    await api.get('/api/clubs').then((response) => {
      const data = response.data
      setClubs(data)
    })
  }

  useEffect(() => {
    setPageTitle("Clubes")
    setLoading(true)

    const fetchData = async () => {
      await getClubs()
    };

    fetchData().then(setLoading(false))
  }, [])

  const columns: any = [
    {
      name: 'razao_social', label: 'Razão Social', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'cnpj', label: 'Cnpj', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: '', label: '', options: {
        filter: false,
        false: true,
        customBodyRenderLite: (index: string | number) => {return (
            <>
              <Link className='btn btn-sm btn-warning' to={`/admin/clubs/update/${clubs[index]?.id}`} title="Editar"><i className="bi bi-pencil" aria-hidden="true"></i> </Link>
            </>
          )
        },
      },
    },
  ]

  const options: any = DataTableOptions

  return (
    <>

      <div className='mb-4'>
        <Link className='btn btn-success mb-3' to='/admin/clubs/create'><i className="bi bi-plus-circle">&nbsp;</i> Cadastrar Clube</Link>

        <MUIDataTable
          title={''}
          data={clubs}
          columns={columns}
          options={options}
        />
      </div>

    </>
  )
}